import { Directive, input } from '@angular/core';

/**
 * Marks an input as `type="number"` and blocks 'e', 'E', '+', and '-' by default.
 *
 * See the `allowSpecialKeys` input if your field requires scientific notation or signed values.
 */
@Directive({
    selector: 'input[qpxNumber]',
    host: {
        '[attr.type]': '"number"',
        '(keydown)': 'onKeyDown($event)',
    },
})
export class QpxNumber {
    //#region Constants
    private readonly BLOCKED_KEYS = new Set(['e', 'E', '+', '-']);
    //#endregion

    //#region Inputs
    /**
     * If true, allows keys ('e', 'E', '+', '-') for scientific/signed number input.
     */
    public readonly allowSpecialKeys = input(false);
    //#endregion

    //#region Template methods
    protected onKeyDown(event: KeyboardEvent): void {
        if (!this.allowSpecialKeys() && this.BLOCKED_KEYS.has(event.key)) {
            event.preventDefault();
        }
    }
    //#endregion
}
